import { e as o } from "./engine-v8-version.js";
import { f as r } from "./fails.js";
import { g as t } from "./global.js";
var s = t.String,
  e = !!Object.getOwnPropertySymbols && !r(function () {
    var r = Symbol();
    return !s(r) || !(Object(r) instanceof Symbol) || !Symbol.sham && o && o < 41;
  });
export { e as s };